<entitetikon [type]="entitetType()" class="ikon"/>
<span class="beskrivelse">
  @switch (indeksertEntitet()) {
    @case (indekserteEntiteter.sak) {
      <span class="hoved">
        <span class="prefiks">{{ 'Sak'|translate }} {{ somSak().nummer }}</span>
        <span class="tittel">{{ somSak().tittel }}</span>
      </span>
      <span class="sub">
        {{ 'I'|translate }}
        <entitetikon [type]="entitetTyper['møte']" inline="true"/>
        {{ somSak().forelderinfo.moete }} {{ somSak().forelderinfo.moetenummer }}, {{ somSak().dato|millissidenepochSomZonedDateTime|zoneddatetimeSomPlaindate|plaindate }}
        <!-- i ajs vises også gruppe, legg til dette når behovet oppstår ... -->
      </span>
      @if (visTekstmatch() && treff().highlight.beskrivelse) {
        <div class="tekstmatch" [innerHTML]="tekstmatchFraTreff('beskrivelse')"></div>
      }
    }
    @case (indekserteEntiteter.opplastetDokumentVersjon) {
      <span class="hoved">
        <!--<span class="prefiks">
          @if (erArkivdokumentTreff(treff)) {
            {{ 'Arkivdokumentt'|translate }}
          } @else {
            {{ 'Saksdokument'|translate }}
          }
        </span>-->
        <span class="tittel">{{ somDokument().filnavn }}</span>
      </span>
      <span class="sub">
        @if (erArkivdokumentTreff()) {
          {{ "I bibliotek under"|translate }}
          <entitetikon [type]="entitetTyper.arkivMappenode" inline="true"/> {{ somDokument().forelderinfo.mappenavn }}
        } @else {
          {{ "Tilknyttet"|translate }}
          <entitetikon [type]="entitetTyper.sak" inline="true"/> {{ somDokument().forelderinfo.sak }}
          <entitetikon [type]="entitetTyper['møte']" inline="true"/> {{ somDokument().forelderinfo.moete }}, {{ somDokument().forelderinfo.moetedato|zoneddatetimeSomPlaindate|plaindate }}
        }
      </span>
      @if (visTekstmatch() && treff().highlight.innhold) {
        <div class="tekstmatch" [innerHTML]="tekstmatchFraTreff('innhold')"></div>
      }
    }
    @case (indekserteEntiteter.beslutning) {
      <span class="hoved">
        <span class="prefiks">{{ 'Beslutning'|translate }}</span>
        <span class="tittel">{{ somBeslutning().tittel }}</span>
      </span>
      <span class="sub">
        {{ 'Tilknyttet'|translate }}
        <entitetikon [type]="entitetTyper.sak" inline="true"/>
        {{ somBeslutning().forelderinfo.sak }}
        <entitetikon [type]="entitetTyper['møte']" inline="true"/>
        {{ somBeslutning().forelderinfo.moete }}, {{ somBeslutning().forelderinfo.moetedato|zoneddatetimeSomPlaindate|plaindate }}
      </span>
      @if (visTekstmatch() && treff().highlight.beskrivelse) {
        <div class="tekstmatch" [innerHTML]="tekstmatchFraTreff('beskrivelse')"></div>
      }
    }
    @case (indekserteEntiteter.oppgave) {
      <span class="hoved">
        <span class="prefiks">{{ 'Oppgave'|translate }}</span>
        <span class="tittel">{{ somOppgave().tittel }}</span>
      </span>
      <div class="sub">
        <div class="meta">
          {{ 'Frist {forfallsdato}, ansvarlig {ansvarlig}.'|translate : {forfallsdato: somOppgave().dato|millissidenepochSomZonedDateTime|zoneddatetimeSomPlaindate|plaindate, ansvarlig: oppgaveansvarlig()} }}
          @if (somOppgave().forelderinfo?.malnavn) {
            {{ 'Tilknyttet'|translate }}
            <span [innerHTML]="somOppgave().forelderinfo | strengMal:'lang'"></span>
          }
        </div>
        @if (visTekstmatch()) {
          @if (treff().highlight.beskrivelse) {
            <div class="tekstmatch" [innerHTML]="tekstmatchFraTreff('beskrivelse')"></div>
          } @else if (treff().highlight.tittel) {
            <div class="tekstmatch" [innerHTML]="tekstmatchFraTreff('tittel')"></div>
          }
        }
      </div>
    }
  }
</span>
<span class="handling">
  <ng-content/>
</span>
